import { render, staticRenderFns } from "./GenreMaster.vue?vue&type=template&id=72335bde"
import script from "./GenreMaster.vue?vue&type=script&lang=js"
export * from "./GenreMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports